import { render, staticRenderFns } from "./kucunluru.vue?vue&type=template&id=658eba28&scoped=true&"
import script from "./kucunluru.vue?vue&type=script&lang=js&"
export * from "./kucunluru.vue?vue&type=script&lang=js&"
import style0 from "./kucunluru.vue?vue&type=style&index=0&id=658eba28&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658eba28",
  null
  
)

export default component.exports